/**
 * 註冊相關的提示文案（彈窗版 LoginDialog 與整頁版 Login 共用一份）。
 *
 * 口徑來自後端 `GET /auth/registerOptions`：
 *   · signup_bonus    —— 註冊贈送多少積分（0 = 不送）
 *   · invite_optional —— 平台是否已設自營經銷商（true = 沒邀請碼也能註冊）
 *
 * ★兩條口徑：
 *   1) **按真實配置說話** —— 管理端沒配贈送（bonus = 0）時，絕不能寫「填寫邀請碼可獲贈積分」，
 *      那是在承諾一件不會發生的事（2026-10-16 用戶指出）；
 *   2) **不寫具體數字**（用戶 2026-10-16 明確要求）—— 只說「可獲贈積分」。
 *      額度在管理端是可以隨時調的，把數字寫進文案既不靈活、也容易過期。
 */

/**
 * @param {object} o
 * @param {boolean} o.isRegister  是否在註冊模式（登入模式回登入宣傳語）
 * @param {number}  o.signupBonus 贈送積分（僅用於判斷「有沒有贈送」，0 = 不送）
 * @param {boolean} o.inviteOptional 沒邀請碼能不能註冊
 * @returns {string}
 */
export function registerSubText({ isRegister, signupBonus, inviteOptional }) {
  if (!isRegister) {
    return '登入後，用 AI 產生電商主圖、詳情圖與短影片'
  }
  const gift = (Number(signupBonus) || 0) > 0 ? '可獲贈積分' : ''
  if (inviteOptional) {
    // 平台有自營經銷商 → 沒碼也能註冊
    return gift
      ? `填寫邀請碼${gift}；沒有邀請碼也可以直接註冊`
      : '沒有邀請碼也可以直接註冊；有邀請碼的在下方填入'
  }
  // 沒碼就不能註冊
  return gift
    ? `填寫經銷商提供的邀請碼即可註冊，${gift}`
    : '填寫經銷商提供的邀請碼即可註冊，註冊後自動登入'
}

/**
 * 邀請碼輸入框的 placeholder。
 *
 * 刻意**不**把「可獲贈 N 積分」塞進 placeholder：那句話由輸入框下方的
 * 小字提示承擔（帶禮物圖示、更醒目），placeholder 只講「必填還是選填」。
 * 塞兩處會在同一屏裡重複同一句話。
 */
export function invitePlaceholderText({ inviteOptional }) {
  return inviteOptional ? '邀請碼（選填）' : '邀請碼（必填，向經銷商索取）'
}
